@if (selectedOptions.length > 0) {
  <span class="select-text">
    @for (
      option of displayAll ? selectedOptions : (selectedOptions | take: maxDisplayed);
      track option
    ) {
      <span class="select-pill fluid flex-nowrap">
        <span
          [innerHTML]="
            option?.element?.nativeElement?.innerHTML || option?.value | secureHtml
          "
        ></span>
        @if (!readonly) {
          <i class="fa-regular fa-xmark pointer ml-1" (click)="onDelete(option)"></i>
        }
      </span>
    }
    @if (displayAll === false && selectedOptions.length > maxDisplayed + 1) {
      <span class="soft-link small fluid flex-nowrap" (click)="displayAll = true">
        {{
          '#UI_CORE.COMPONENTS.MULTI_SELECT.DISPLAY_MORE_PL'
            | translate
            | interpolate: { count: selectedOptions.length - maxDisplayed }
        }}
      </span>
    }
    @if (displayAll === false && selectedOptions.length === maxDisplayed + 1) {
      <span class="soft-link small fluid flex-nowrap" (click)="displayAll = true">
        {{ '#UI_CORE.COMPONENTS.MULTI_SELECT.DISPLAY_MORE_SG' | translate }}
      </span>
    }
    @if (displayAll === true && selectedOptions.length > maxDisplayed) {
      <span class="soft-link small fluid flex-nowrap" (click)="displayAll = false">
        {{ '#UI_CORE.COMPONENTS.MULTI_SELECT.DISPLAY_LESS' | translate }}
      </span>
    }
  </span>
} @else {
  <span class="select-text truncate pointer select-placeholder" (click)="onClick()">{{
    placeholder || ('#UI_CORE.COMPONENTS.MULTI_SELECT.PLACEHOLDER' | translate)
  }}</span>
}

@if (isOpen) {
  <div
    class="select-panel"
    [style]="{ top: panelTop + 'px' }"
    (softClickOutside)="onOutsideClick()"
    [delayClickOutsideInit]="true"
  >
    <div class="soft-scroll vertical select-panel-items-multi">
      @for (option of options; track option) {
        @if (isHeader(option)) {
          <div class="select-option-header">
            {{ option.text() }}
          </div>
        }
        @if (isSeparator(option)) {
          <div class="select-option-separator">
            <hr />
          </div>
        }
        @if (isOption(option)) {
          <div
            class="select-option flex"
            [class.disabled]="option.disabled()"
            [class.pointer]="!option.disabled()"
            (click)="!option.disabled() ? onSelect(option) : undefined"
          >
            <soft-checkbox
              [class.pointer]="!option.disabled()"
              [readonly]="option.disabled()"
              [checked]="option | in: temporaryOptions"
              (checkedChange)="!option.disabled() ? onSelect(option) : undefined"
              (click)="$event.stopPropagation()"
            >
            </soft-checkbox>
            <span
              class="soft-label right flex items-center"
              [class.pointer]="!option.disabled()"
              [innerHTML]="
                option.element.nativeElement.innerHTML || option.value | secureHtml
              "
            ></span>
          </div>
        }
      }
    </div>
    <a
      id="multiselect-selectAll"
      [class.collapse]="temporaryOptions.length >= selectableOptions.length"
      class="soft-link small mt-2 ml-2"
      (click)="selectAll()"
      >{{ '#UI_CORE.COMPONENTS.MULTI_SELECT.SELECT_ALL' | translate }}
    </a>
    <a
      [class.collapse]="temporaryOptions.length < selectableOptions.length"
      class="soft-link small mt-2 ml-2"
      (click)="selectNone()"
      >{{ '#UI_CORE.COMPONENTS.MULTI_SELECT.SELECT_NONE' | translate }}</a
    >
    <div class="w-full p-4">
      <button class="soft-button primary w-full h-16 rounded" (click)="onSubmitPanel()">
        {{ '#UI_CORE.COMPONENTS.MULTI_SELECT.SUBMIT' | translate }}
      </button>
    </div>
  </div>
}
@if (isOpen) {
  <span class="soft-backdrop mobile-only z-300" (click)="onOutsideClick()"></span>
}

@if (!readonly && isOpen) {
  <i class="fa-regular fa-chevron-up pointer" (click)="onClick()"></i>
}
@if (!readonly && !isOpen) {
  <i class="fa-regular fa-chevron-down pointer" (click)="onClick()"></i>
}
